// extracted by mini-css-extract-plugin
module.exports = {"page":"Contact_page__2pGMN","title":"Contact_title__1JASG","formCard":"Contact_formCard__3DC72"};